import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useCallback } from 'react';
var hiddenStyles = {
  display: 'none'
};

function HiddenText(_ref) {
  var id = _ref.id,
      value = _ref.value;
  return React.createElement("div", {
    id: id,
    style: hiddenStyles
  }, value);
}

var visuallyHidden = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  whiteSpace: 'nowrap'
};

function LiveRegion(_ref2) {
  var id = _ref2.id,
      announcement = _ref2.announcement;
  return React.createElement("div", {
    id: id,
    style: visuallyHidden,
    role: "status",
    "aria-live": "assertive",
    "aria-atomic": true
  }, announcement);
}

function useAnnouncement() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      announcement = _useState2[0],
      setAnnouncement = _useState2[1];

  var announce = useCallback(function (value) {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce: announce,
    announcement: announcement
  };
}

export { HiddenText, LiveRegion, useAnnouncement };